/**
 * CompanyStatusBadge — per-company enablement indicator.
 * Blue circle + check when enabled, dashed outline when not — same circle/badge
 * treatment as MasterCrudTable's CompanyStatusBadge, but using the actual lucide
 * `Building2` icon (the same one the Acciones column button uses) instead of a
 * hand-copied SVG that only looked similar.
 *
 * @module components/list/CompanyStatusBadge
 */
import React from 'react';
import { Building2 } from 'lucide-react';

export interface CompanyStatusBadgeProps {
  enabled: boolean;
  enabledLabel: string;
  notEnabledLabel: string;
}

export function CompanyStatusBadge({ enabled, enabledLabel, notEnabledLabel }: CompanyStatusBadgeProps) {
  if (enabled) {
    return (
      <span title={enabledLabel} className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#dbeefe] dark:bg-primary-900/20 text-primary-600 dark:text-primary-500 relative">
        <Building2 size={17} />
        <span className="absolute -bottom-0.5 -right-0.5 bg-white dark:bg-dark-bg-primary rounded-full leading-none p-px">
          <svg className="w-2.5 h-2.5 text-green-600" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
        </span>
      </span>
    );
  }
  return (
    <span title={notEnabledLabel} className="inline-flex items-center justify-center w-7 h-7 rounded-full border border-dashed border-border-primary dark:border-dark-border-primary text-content-secondary dark:text-dark-content-secondary">
      <Building2 size={17} strokeWidth={1.75} />
    </span>
  );
}
